import { enableDragToScroll } from "./dragToScroll.js";

class VisualFilters extends HTMLElement {
  constructor() {
    super();
    this._lastSearch = window.location.search;
    this._onUrlChange = this._onUrlChange.bind(this);
  }

  connectedCallback() {
    this.container = this.querySelector(".visual-filters");
    this.visualFiltersList = this.querySelectorAll(".visual-filter");

    this.setEventListeners();

    window.addEventListener("urlchange", this._onUrlChange);
    this.appendCurrentParamsToLinks?.();
  }

  disconnectedCallback() {
    window.removeEventListener("urlchange", this._onUrlChange);
  }

  setEventListeners() {
    if (this.container) {
      enableDragToScroll(this.container);
    } else {
      console.warn("No .visual-filters container found.");
    }
  }

  _onUrlChange() {
    const currentSearch = window.location.search;
    if (currentSearch !== this._lastSearch) {
      this._lastSearch = currentSearch;
      this.appendCurrentParamsToLinks();
    }
  }

  appendCurrentParamsToLinks() {
    const currentParams = window.location.search;
    if (!currentParams) return;

    const links = this.querySelectorAll(".visual-filter__link");
    links.forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);

        url.search = currentParams;

        link.href = url.toString();
      } catch (e) {
        console.warn("Invalid link URL:", link.href, e);
      }
    });
  }
}

customElements.define("visual-filters", VisualFilters);
